'use client';

import { MathManager } from '@payments-checkout/shared/helpers/managers/mathManager';
import { Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';

export function DeliveryCard({
  deliveryDays,
  deliveryCost,
}: {
  deliveryDays?: number | null;
  deliveryCost?: number;
}) {
  const { formatMessage } = useIntl();

  const formattedDeliveryCost = MathManager.formatCurrency({
    value: (deliveryCost || 0) / 100,
  });

  return (
    <>
      <Text variant="heading-small" color="high">
        {formatMessage({ id: 'checkout.delivery.title' })}
      </Text>
      <div className="my-jade-100 flex flex-col gap-jade-50 py-jade-150 px-jade-200 bg-jade-background-surface rounded-jade-small border border-solid border-jade-border-low shadow-sm">
        {deliveryDays != null && (
          <Text color="high" variant="text-medium" weight="semibold">
            {formatMessage(
              { id: 'checkout.delivery.estimatedTimeLabel' },
              { days: deliveryDays }
            )}
          </Text>
        )}
        <Text color="high" variant="text-medium" weight="regular">
          {formattedDeliveryCost}
        </Text>
      </div>
    </>
  );
}
